import { jsonMember, jsonObject } from 'typedjson';
import { Guid, Nillable } from '@web/utils';

@jsonObject
export class AdminDictionaryProductAttributeRequest {
  @jsonMember(String)
  public readonly productAttributeId!: Guid;

  @jsonMember(String)
  public readonly value!: string;

  @jsonMember(String)
  public readonly id?: Nillable<string>;

  public constructor(
    private readonly data: {
      id?: Nillable<Guid>;
      productAttributeId: Guid;
      value: string;
    },
  ) {
    this.id = data.id;
    this.productAttributeId = data.productAttributeId;
    this.value = data.value;
  }
}
